/**
 * External dependencies
 */
import React from 'react';
import classNames from 'classnames';

/**
 * Style dependencies
 */

const NavItem = (props) => {
    return (
        <li className={classNames('section-nav-tab', props.className, { 'is-selected': props.selected })}>
            <a
                href={props.path}
                className={'section-nav-tab__link'}
                onClick={props.onClick}
                disabled={props.disabled}
                role='menuitem'
            >
                <span className='section-nav-tab__text'>{props.children}</span>
            </a>
        </li>
    );
};

export default NavItem;
